var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-view"},[_c('div',{staticClass:"wrap-in"},[_c('span',{staticClass:"back-button",on:{"click":_vm.setReturn}},[_c('font-awesome-icon',{attrs:{"icon":_vm.faArrowLeft}})],1),_c('h2',[_vm._v("Coming soon")]),_c('p',[_vm._v("This page is under construction.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }